import { createContext, useContext } from 'react';

export type TokenRefresherContextValue = {
  /**
   * Function that refreshes the access token and returns the new token.
   * Returns a promise that resolves with the new token string.
   * If token refresh fails, the promise will reject.
   */
  refreshToken: () => Promise<string>;
} | null;

const TokenRefresherContext = createContext<TokenRefresherContextValue>(null);

export const TokenRefresherContextProvider = TokenRefresherContext.Provider;

/**
 * Hook to access the token refresher function from context.
 * Returns null if no token refresher is provided in context.
 */
export function useTokenRefresherContext(): TokenRefresherContextValue {
  return useContext(TokenRefresherContext);
}
